<template>
    <Modal v-if="shown"
           :title="isEditMode
                    ? $t('user.apiKeys.modal.edit.title')
                    : $t('user.apiKeys.modal.add.title')"
           @close="show(false)"
           :close-on-click-outside="false"
    >
        <template v-slot:body>
            <form class="flex flex_column modal-content">
                <md-field :class="[{ 'md-error': errors.has('name') }]">
                    <label>{{ $t("user.apiKeys.table.header.name") }}</label>
                    <md-input v-model="form.name"
                              required
                              data-vv-name="name"
                              v-validate="modelValidations.name"
                    ></md-input>
                    <span v-if="errors.has('name')" class="validation-error">{{ errors.first("name") }}</span>
                </md-field>
				<div class="flex flex_items_center">
					<md-checkbox v-model="form.usedByPartner" :disabled="isEditMode">
						{{ form.syncedWithPartner ? $t("user.apiKeys.modal.usedByPartnerWithSync") : $t("user.apiKeys.modal.usedByPartner") }}
					</md-checkbox>
					<el-tooltip :open-delay="300" placement="right"
								:content="$t('user.apiKeys.modal.usedByPartner.tooltip')">
						<i class="fa fa-info-circle secondary_color" aria-hidden="true"></i>
					</el-tooltip>
				</div>
<!--				<md-checkbox v-model="form.usedByPartner" disabled="isEditMode">
					{{ form.syncedWithPartner ? $t("user.apiKeys.modal.usedByPartnerWithSync") : $t("user.apiKeys.modal.usedByPartner") }}
				</md-checkbox>-->
                <md-checkbox v-model="form.generateNewKey" v-if="isEditMode">
                    {{ $t("user.apiKeys.modal.generateNewKey") }}
                </md-checkbox>
            </form>
            <div class="text_left light_bg_color margin_top" v-if="form.generateNewKey || !isEditMode">
                <span class="font_bold">{{$t("common.hint")}}：</span>
                <br/>
                <span>{{$t("user.apiKeys.modal.hint.newKeyInfo")}}</span>
            </div>
            <div class="flex flex_end margin_top">
                <md-button :class="{'md-primary': isFormValid}" @click="editKey" v-if="isEditMode">
                    {{$t("common.edit")}}
                </md-button>
                <md-button :class="{'md-primary': isFormValid}" @click="addKey" v-else>
                    {{$t("common.button.submit")}}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import {validateForm, validateRequiredFields} from "@/validation/validation";

export default {
    components: { Modal },
    data() {
        return {
            apiKeyData: null,
            shown: false,
            form: {
                name: "",
				usedByPartner: false,
				syncedWithPartner: false,
                generateNewKey: false,
            },
            modelValidations: {
                name: {
                    required: true
                },
            }
        };
    },
    computed: {
        isEditMode() {
            return this.apiKeyData && this.apiKeyData.id;
        },
        isFormValid() {
            return validateRequiredFields(this.form, this.modelValidations);
        }
    },
    methods: {
        show(value) {
            this.shown = value;
        },
        showWithData(data) {
            this.apiKeyData = data;
            this.form = { ...data }
            this.show(true);
        },
        editKey() {
            validateForm(this, this.$validator)
                .then(() => {
                    this.$emit("edit", this.form);
                });
        },
        addKey() {
            validateForm(this, this.$validator)
                .then(() => {
                    this.$emit("add", this.form);
                });
        },
    },
};
</script>